import { type FC } from 'react';
import { Button } from 'react-bootstrap';
import { css } from '@emotion/css';
import { colors } from '@editor2/styles/colors';

interface Props {
	icon: React.ReactNode;
	children: React.ReactNode;
	onClick: (_) => void;
}

const IconTextButton: FC<Props> = (props) => {
	const { icon, children, onClick } = props;
	return (
		<Button variant="outline-secondary" onClick={onClick} className={buttonStyle}>
			{icon}
			{children}
		</Button>
	);
};

export default IconTextButton;

export const buttonStyle = css`
	border: none !important;
	font-size: 14px !important;

	:hover {
		color: ${colors.mainText} !important;
		border-color: ${colors.border} !important;
		background-color: ${colors.background} !important;
	}

	svg {
		margin-right: 5px;
	}
`;
